import { Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgApexchartsModule } from 'ng-apexcharts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutComponent } from './layout.component';
import { FooterComponent } from 'src/app/components/common/footer/footer.component';
import { HeaderComponent } from 'src/app/components/common/header/header.component';
import { SidebarComponent } from 'src/app/components/common/sidebar/sidebar.component';
import { CustomizerSettingsComponent } from 'src/app/components/customizer-settings/customizer-settings.component';
import { LayoutRoutingModule } from './layout-routing.module';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FullCalendarModule } from '@fullcalendar/angular';
import { NgChartsModule } from 'ng2-charts';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxEditorModule } from 'ngx-editor';
import { NgxGaugeModule } from 'ngx-gauge';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { QuillModule } from 'ngx-quill';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/core/shared-modules/shared.module';
import { SocketIoModule } from 'ngx-socket-io';
import { MailBoxService } from 'src/app/core/services/mail-box/mail-box.service';
import { DecodeURIComponentPipe } from 'src/app/core/pipe/decode-uricomponent.pipe';
//import { SocketNotifications } from './services/socket-notifications.service';
//import { SocketMail } from './services/socket-mail.service';
import { TruncatePipe } from 'src/app/core/pipe/truncate.pipe';
import { NetworkPopupComponent } from 'src/app/core/shared-modules/components/network-popup/network-popup.component';
@NgModule({
    declarations: [
        LayoutComponent,
        SidebarComponent,
        FooterComponent,
        HeaderComponent,
        CustomizerSettingsComponent,
    ],

    imports: [
        SharedModule,
        CommonModule,
        LayoutRoutingModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        NgApexchartsModule,
        FullCalendarModule,
        NgScrollbarModule,
        CarouselModule,
        NgxEditorModule,
        DragDropModule,
        HttpClientModule,
        CdkAccordionModule,
        NgxGaugeModule,
        NgChartsModule,
        NgxMatTimepickerModule,
        NgxDropzoneModule,
        ColorPickerModule,
        NgxEchartsModule.forRoot({
            echarts: () => import('echarts'),
        }),
        QuillModule.forRoot(),
        NetworkPopupComponent
        // SocketIoModule,
    ],
    providers: [
        MailBoxService,
        DecodeURIComponentPipe,
        // SocketNotifications,
        // SocketMail,
        TruncatePipe
    ]
})
export class LayoutModule { }
